export const GET_TEMPLATES = 'GET_TEMPLATES'
export const CREATE_TEMPLATES = 'CREATE_TEMPLATES'
export const EDIT_TEMPLATES = 'EDIT_TEMPLATES'
export const DELETE_TEMPLATES = 'DELETE_TEMPLATES'
export const GET_REPORT = "GET_REPORT"
export const RESET_TEMPLATES="RESET_TEMPLATES"

